import drop from './drop';

/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */
function tail(array) {
  return drop(array, 1);
}

export default tail;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/tail.js
// module id = null
// module chunks = 